import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { CheckCircle2, Truck, Home as HomeIcon } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";

const OrderSuccess = () => {
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  useEffect(() => {
    api.get(`/orders/${id}`).then((r) => setOrder(r.data)).catch(() => {});
  }, [id]);

  return (
    <div className="mx-auto max-w-2xl px-6 py-20 text-center" data-testid="order-success-page">
      <div className="mx-auto h-16 w-16 rounded-full bg-[#F0EFEA] flex items-center justify-center mb-5">
        <CheckCircle2 className="h-8 w-8 text-[#81B29A]" strokeWidth={1.8} />
      </div>
      <div className="tick-label mb-2">Order confirmed</div>
      <h1 className="font-heading text-4xl text-[#2C3E2D] font-medium">Thank you for your order</h1>
      <p className="text-sm text-[#6B7B6C] mt-3">
        We&apos;re prepping your basket now. You&apos;ll get updates as your order moves.
      </p>

      {order && (
        <div className="mt-8 rounded-2xl border border-[#E5E5E0] bg-white p-6 text-left" data-testid="order-details">
          <div className="flex justify-between items-center">
            <div>
              <div className="text-xs uppercase tracking-widest text-[#6B7B6C]">Order ID</div>
              <div className="font-heading text-lg text-[#2C3E2D]" data-testid="order-id-value">{order.order_id}</div>
            </div>
            <div className="text-right">
              <div className="text-xs uppercase tracking-widest text-[#6B7B6C]">Status</div>
              <div className="text-sm font-medium text-[#E07A5F] capitalize">{order.order_status.replace("_", " ")}</div>
            </div>
          </div>
          <div className="mt-4 border-t border-[#E5E5E0] pt-4 space-y-2 text-sm">
            <Row label="Items" value={`${order.items.length} product${order.items.length > 1 ? "s" : ""}`} />
            <Row label="Payment" value={order.payment_method === "cod" ? "Cash on Delivery" : "Razorpay"} />
            <Row label="Total" value={`₹${order.total.toFixed(2)}`} />
          </div>
        </div>
      )}

      <div className="mt-8 flex justify-center gap-3">
        <Link to="/account"><Button className="btn-outline-dark rounded-full px-6" data-testid="view-orders-btn"><Truck className="h-4 w-4 mr-2" />My Orders</Button></Link>
        <Link to="/"><Button className="btn-primary rounded-full px-6" data-testid="home-btn"><HomeIcon className="h-4 w-4 mr-2" />Back home</Button></Link>
      </div>
    </div>
  );
};

const Row = ({ label, value }) => (
  <div className="flex justify-between">
    <span className="text-[#6B7B6C]">{label}</span>
    <span className="text-[#2C3E2D] font-medium">{value}</span>
  </div>
);

export default OrderSuccess;
